import fetchServer from "../fetchServer";

/** Posts onto the order thread. The id is the flight booking, and the body
 * is multipart: a message, plus an optional image. A file on its own still
 * needs a message — the caller sends a space. */
export default async function addMessageToBooking(id, data) {
  var result = { return: 0, msg: "Failed submiting message", data: [] };

  await fetchServer({
    method: "POST",
    url: `/product/v1/book/addMessage/${id}`,
    data,
  })
    .then((res) => {
      if (res) {
        if (res.status >= 200 && res?.status < 300) {
          result = { return: 1, msg: "Successfull", data: res.data.data };
        } else if (res?.data?.error) result["msg"] = res.data.error;
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
